<template>
  <div id="activity">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style>
#activity{
  height: 100%;
}
</style>